import styled from "styled-components";

export const Styles = styled.div`
  .mobile & {
    --text-align: center;
  }

  .title {
    text-align: var(--text-align);
    font-weight: 700;
    font-size: 24px;
    margin: 0;
    color: var(--color-item);

    &--clickable {
      cursor: pointer;
    }
  }
  .sub-title {
    text-align: var(--text-align);
    color: var(--color-sub);
  }
`;
